import { getCartDetails } from '../datafetchers/CategoryPage';
import Cookies from 'js-cookie';

export const getLoginCartItems = async () => {
  const response = await getCartDetails();
  if (response.success) {
    const productArray = response?.data?.cart_products;
    Cookies.set('cart_items', productArray?.toString());
    return productArray;
  } else {
    return [];
  }
};
